import { Link } from 'gatsby'
import FavoritesCounterCompact from 'src/components/restructure/product/ProductCard/FavoritesCounterCompact'

import type { FeaturedProduct } from './types'

type FeaturedProductCardProps = {
  product: FeaturedProduct
}

export default function FeaturedProductCard({
  product,
}: FeaturedProductCardProps) {
  return (
    <article className="group relative size-full overflow-hidden bg-gradient-to-b from-restructure-background-neutral-4 to-restructure-background-neutral-2">
      <Link
        to={product.productUrl}
        aria-label={`Ver produto ${product.productName}`}
        className="block size-full"
      >
        <img
          src={product.imageUrl}
          alt={product.productName}
          loading="lazy"
          className="size-full object-contain mix-blend-multiply transition-transform duration-300 group-hover:scale-105"
        />

        <span className="sr-only">{product.productName}</span>
      </Link>

      <div className="pointer-events-none absolute left-3 top-3 z-10">
        <FavoritesCounterCompact
          productId={product.productId}
          dataDyId="favorites-counter-featured-card"
        />
      </div>
    </article>
  )
}
